/* eslint-disable no-useless-escape */
import { DefaultOptionType } from 'antd/es/select';
import { IDataHasTreeOTM } from 'src/types/common.type';
import { ELoaiHinhNhanVien, ETrangThaiNhanVien } from 'src/types/enum';
import { INhanVien } from 'src/types/NhanVien.type';
import CONTANTS from './constants';

export default class FUNCS {
  static truncateString(input: string, size = CONTANTS.MAX_CHAR_SIZE_TABLE) {
    if (!input) return '';
    return input.length > size ? `${input.substring(0, size)}...` : input;
  }

  static makeid(length = 8) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_';

    for (let i = 0; i < length; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  static isValidURL(str = '') {
    const res = str.match(
      /(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
    );
    return res !== null;
  }

  static isValiCharactersFile(value: string) {
    const regex = /[\/#]/;
    const res = regex.test(value);

    return res;
  }

  static onKeyDownNumber(event: any) {
    const k = event.which;
    if ((k < 48 || k > 57) && (k < 96 || k > 105) && k !== 8 && k !== 190) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  static removeDiacritics(str: string) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    return str;
  }

  static getFullUrl(path?: string | null) {
    if (!path) return '';
    const [bucket, url] = path.split(';');
    return `${process.env.REACT_APP_IMG_URL}/${bucket}/${url}?v=${Date.now()}`;
  }

  static getFileNameFromPath(path?: string) {
    if (!path) return '';
    const parts = path.split(';');
    return parts[parts.length - 1] || path;
  }

  static isImagePath(path?: string) {
    if (!path) return false;
    const fileName = FUNCS.getFileNameFromPath(path);
    return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(fileName);
  }

  static download(data: any, filename: string, type: string) {
    const file = new Blob([data], { type });
    const a = document.createElement('a');
    const url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  static getSearchParams(searchParams: URLSearchParams) {
    const result: any = {};
    searchParams.forEach((val, key) => {
      result[key] = val;
    });

    return result;
  }

  static convertPrice(n?: number | string, unit: string = 'đ') {
    if (!n) return `0`;

    const price = (Math.round(Number(n) * 10) / 10).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    if (unit === '') {
      return price;
    }
    return `${price} ${unit}`;
  }

  static onDownload = (src: string, name?: string) => {
    fetch(src)
      .then((response) => response.blob())
      .then((blob) => {
        const url = URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.download = name || `dl_file_${Date.now()}`;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.remove();
      });
  };

  static getTreeDataTable<T extends IDataHasTreeOTM>(items: T[], parent_id?: string): DefaultOptionType[] {
    return items
      .filter((i) => {
        return parent_id ? i.parent_id === parent_id : !i.parent_id;
      })
      .map((i) => {
        return {
          ...i,
          children: FUNCS.getTreeDataTable(items, i.id),
        };
      });
  }

  static getTreeDataOTM<T extends IDataHasTreeOTM>(items: T[], parent_id?: string): DefaultOptionType[] {
    return items
      .filter((i) => {
        return parent_id ? i.parent_id === parent_id : !i.parent_id;
      })
      .map((i) => {
        return {
          label: i.name || i.label,
          title: i.name || i.label,
          value: i.id,
          data: i,
          // value: i.id,
          children: FUNCS.getTreeDataOTM(items, i.id),
        };
      });
  }

  static getFullName(item?: INhanVien) {
    if (!item) return '';
    return `${item.Ho || ''} ${item.Ten || ''}`.trim();
  }

  static renderLoaiHinhNhanVien(value?: ELoaiHinhNhanVien) {
    let color = 'default';
    let text = 'Không xác định';

    switch (value) {
      case ELoaiHinhNhanVien.ThucTap:
        color = 'lime';
        text = 'Thực tập';
        break;
      case ELoaiHinhNhanVien.CTV:
        color = 'green';
        text = 'Cộng tác viên';
        break;
      case ELoaiHinhNhanVien.ThuViec:
        color = 'cyan';
        text = 'Thử việc';
        break;
      case ELoaiHinhNhanVien.ChinhThuc:
        color = 'purple';
        text = 'Chính thức';
        break;

      default:
        break;
    }
    return { color, text };
  }

  static renderTrangThai(value?: ETrangThaiNhanVien) {
    let color = 'default';
    let text = 'Không xác định';

    switch (value) {
      case ETrangThaiNhanVien.DaNghiViec:
        color = 'error';
        text = 'Đã nghỉ việc';
        break;
      case ETrangThaiNhanVien.DangLamViec:
        color = 'processing';
        text = 'Đang làm việc';
        break;
      case ETrangThaiNhanVien.HoanLamViec:
        color = 'warning';
        text = 'Hoãn làm việc';
        break;

      default:
        break;
    }
    return { color, text };
  }

  static parseTaiLieuDinhKem(value?: string): string[] {
    if (!value) return [];
    if (value.includes(',')) {
      return value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter((item) => typeof item === 'string' && item);
      }
    } catch {
      // not JSON
    }
    return [value];
  }

  static stringifyTaiLieuDinhKem(paths: string[]) {
    return paths.filter(Boolean).join(',');
  }

  /** Parse kế hoạch tuần: "1,2" → ["1","2"] */
  static parseKeHoachTuan(value?: string): string[] {
    if (!value) return [];
    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)
      .sort((a, b) => Number(a) - Number(b));
  }

  /** Format kế hoạch tuần: ["1","2"] → "1,2" */
  static stringifyKeHoachTuan(tuan: Array<string | number> = []) {
    return tuan
      .map((item) => String(item).trim())
      .filter(Boolean)
      .sort((a, b) => Number(a) - Number(b))
      .join(',');
  }

  /** Hiển thị kế hoạch tuần: "1,2" → "Tuần 1, 2" */
  static formatKeHoachTuan(value?: string) {
    const tuan = FUNCS.parseKeHoachTuan(value);
    if (!tuan.length) return '-';
    return `Tuần ${tuan.join(', ')}`;
  }

  /** KR liên kết chưa được người nhận chấp nhận (chưa có idCapDuoiDuyet) */
  static isKrLienKetChoNhan(item: { idKrLienKet?: number; idCapDuoiDuyet?: number }) {
    return !!item.idKrLienKet && !item.idCapDuoiDuyet;
  }

  /** KR con trong danh sách liên kết chưa được nhận */
  static isKrLienKetChildChoNhan(item: { idCapDuoiDuyet?: number }) {
    return !item.idCapDuoiDuyet;
  }

  /** KR phòng ban chưa có nhân sự nhận (còn gán phòng ban, chưa có idNhanVien) */
  static isKrPhongBanChoNhan(item: { idPhongBan?: number; idNhanVien?: number }) {
    return !!item.idPhongBan && !item.idNhanVien;
  }

  static getTenNgayTrongTuan(ngay: number) {
    const map: Record<number, string> = {
      1: 'Thứ 2',
      2: 'Thứ 3',
      3: 'Thứ 4',
      4: 'Thứ 5',
      5: 'Thứ 6',
      6: 'Thứ 7',
      7: 'Chủ nhật',
    };
    return map[ngay] ?? '';
  }
}
